module.exports = __webpack_public_path__ + "media/images/icon_person-8f66fb81092a2e50344aa321b3d266d3.svg";